// Warning, all icons are fontawesome ones, as such they must be imported in App.vue
export const EVENTS = {
    OK: {
        text: "En veille",
        icon: "check-circle",
        color: "success"
    },
    UNREACHABLE: {
        text: "Injoignable",
        icon: "broadcast-tower",
        color: "warning"
    },
    FAULTY: {
        text: "Défaut",
        icon: "exclamation-triangle",
        color: "warning"
    },
    ALARM: {
        text: "Alarme",
        icon: "fire-alt",
        color: "danger"
    },


    // Smoke extracting panel
    ALARM_BUS1: {
        text: "Bus 1 en alarme",
        icon: "fire-alt",
        color: "danger"
    },
    ALARM_BUS2: {
        text: "Bus 2 en alarme",
        icon: "fire-alt",
        color: "danger"
    },
    SYSTEM_FAULT: {
        text: "Défaut système",
        icon: "tools",
        color: "warning"
    },
    MAINS_FAULT: {
        text: "Défaut secteur",
        icon: "plug",
        color: "warning"
    },
    BATTERY_FAULT: {
        text: "Défaut batterie interne",
        icon: "car-battery",
        color: "warning"
    },
    EXTPSU_MAINS_FAULT: {
        text: "Défaut secteur AES",
        icon: "plug",
        color: "warning"
    },
    EXTPSU_BATTERY_FAULT: {
        text: "Défaut batterie AES",
        icon: "car-battery",
        color: "warning"
    },

    // Modules
    TEST: {
        text: "Mode essai",
        icon: "user-cog",
        color: "warning"
    },

    DISABLED: {
        text: "Hors-service",
        icon: "exclamation-triangle",
        color: "warning"
    },
    LOW_VOLTAGE: {
        text: "Tension d'alimentation basse",
        icon: "bolt",
        color: "warning"
    },
    HIGH_VOLTAGE: {
        text: "Surtension alimentation",
        icon: "bolt",
        color: "warning"
    },
    VENTING_MCP_ALARM: {
        text: "Alarme ligne BCM désenfumage",
        icon: "fire-alt",
        color: "danger"
    },
    VENTING_MCP_SHORT: {
        text: "Court-circuit ligne BCM désenfumage",
        icon: "bolt",
        color: "warning"
    },
    VENTING_MCP_OPEN: {
        text: "EFL manquant ligne BCM désenfumage",
        icon: "exclamation-triangle",
        color: "warning"
    },
    DETECTOR_ALARM: {
        text: "Alarme ligne détecteurs",
        icon: "fire-alt",
        color: "danger"
    },
    DETECTOR_SHORT: {
        text: "Court-circuit ligne détecteurs",
        icon: "bolt",
        color: "warning"
    },
    DETECTOR_OPEN: {
        text: "EFL manquant ligne détecteurs",
        icon: "exclamation-triangle",
        color: "warning"
    },
    VENTING_OUTPUT_SHORT: {
        text: "Court-circuit ligne DAS",
        icon: "fan",
        color: "warning"
    },
    VENTING_OUTPUT_OPEN: {
        text: "EFL manquant ligne DAS",
        icon: "exclamation-triangle",
        color: "warning"
    },
    SOUNDER_MCP_ALARM: {
        text: "Alarme ligne BCM désenfumage",
        icon: "fire-alt",
        color: "danger"
    },
    SOUNDER_MCP_SHORT: {
        text: "Court-circuit ligne BCM désenfumage",
        icon: "exclamation-triangle",
        color: "warning"
    },
    SOUNDER_MCP_OPEN: {
        text: "EFL manquant ligne BCM désenfumage",
        icon: "exclamation-triangle",
        color: "warning"
    },
    SOUNDER_OUTPUT_SHORT: {
        text: "Court-circuit ligne sirène",
        icon: "volume-mute",
        color: "warning"
    },
    SOUNDER_OUTPUT_OPEN: {
        text: "EFL manquant ligne sirène",
        icon: "exclamation-triangle",
        color: "warning"
    },
    HIGH_SPEED_VENTING_SHORT: {
        text: "Court-circuit ligne DAS moteur grande vitesse",
        icon: "fan",
        color: "warning"
    },
    HIGH_SPEED_VENTING_OPEN: {
        text: "EFL manquant ligne DAS moteur grande vitesse",
        icon: "exclamation-triangle",
        color: "warning"
    },
    LOW_SPEED_VENTING_SHORT: {
        text: "Court-circuit ligne DAS moteur basse vitesse",
        icon: "fan",
        color: "warning"
    },
    LOW_SPEED_VENTING_OPEN: {
        text: "EFL manquant ligne DAS moteur basse vitesse",
        icon: "exclamation-triangle",
        color: "warning"
    },
    VENTING_FAILED: {
        text: "Échec de la mise en marche du moteur d'extraction",
        icon: "fan",
        color: "warning"
    },
    FALLBACK_VENTING_SHORT: {
        text: "Court-circuit ligne DAS tirage naturel",
        icon: "fan",
        color: "warning"
    },
    FALLBACK_VENTING_OPEN: {
        text: "EFL manquant ligne DAS tirage naturel",
        icon: "exclamation-triangle",
        color: "warning"
    }
};
